import Image from 'components/Common/Image/Image'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'

const MALDIVES_BUNDLES_IMAGE_ID = 'hamburguer-menu-maldives'

/**
 * LuxKit List Item does not expose surface/background or hover tokens for highlight rows;
 * keep a narrow override so the default neutral hover does not replace the mint treatment.
 */
const MaldivesBundlesListItem = styled(ClickableListItem)`
  padding: ${rem(8)};
  min-height: ${rem(50)};
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  border-radius: ${props => props.theme.borderRadius.L};

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
      }
    }
  }
`

const MaldivesBundlesImageContainer = styled.div`
  width: ${rem(48)};
  height: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
`

interface Props {
  navItem: App.NavItem
  onNavigate: () => void
}

function NavBarHamburgerMenuMaldivesBundlesBanner(props: Props) {
  const { navItem, onNavigate } = props
  const intl = useIntl()

  const newBadgeText = intl.formatMessage({
    id: 'UJeO-rdvZOfzyeTCI0uv',
    defaultMessage: 'New',
    description: 'New badge label for the navigation list items in the navigation bar',
  })

  return (
    <MaldivesBundlesListItem
      size="medium"
      startIcon={<MaldivesBundlesImageContainer>
        <Image
          id={MALDIVES_BUNDLES_IMAGE_ID}
          dpr={2}
          fit="center"
          objectFit="cover"
        />
      </MaldivesBundlesImageContainer>}
      overline={navItem.newLabel ? newBadgeText : undefined}
      overlineFormat="uppercase"
      title={navItem.text}
      titleColour="normal-contrast"
      href={navItem.href}
      to={navItem.to}
      onClick={onNavigate}
      rel={navItem.target === '_blank' ? 'noopener noreferrer' : undefined}
      target={navItem.target}
      endIcon={<LineAngleRightBIcon />}
    />
  )
}

export default NavBarHamburgerMenuMaldivesBundlesBanner
